<script setup lang="ts">
import type { ArticleContent } from '~/models/Content/ArticleContent'
import useImage from '~/composables/useImage'
import RichTextRenderer from '~/components/utils/RichTextRenderer.vue'
import FullscreenContent from '~/components/utils/FullscreenContent.vue'
import CopyrightButton from '~/components/utils/CopyrightButton.vue'

const { sequence } = defineProps<{
  sequence: ArticleContent
  activeIndex: boolean
}>()

const { getSvgOrImage } = useImage()
const image = getSvgOrImage(sequence.svg, sequence.image)
</script>

<template>
  <FullscreenContent>
    <template #default="{ isFullscreen }">
      <div v-if="image" class="col-start-1 row-start-1 size-full bg-(--theme-5)">
        <img
          :src="image.src"
          :alt="image.altText"
          class="size-full"
          :class="isFullscreen ? 'object-scale-down p-4 place-self-center' : 'object-cover'"
        >
        <template v-if="activeIndex">
          <div class="absolute top-full mt-2 flex flex-col gap-1 text-sm font-light">
            <RichTextRenderer
              v-if="image.caption"
              :text="image.caption"
            />
          </div>
          <CopyrightButton :copyright="image.copyright" class="absolute right-0 bottom-0 z-1" />
        </template>
      </div>
    </template>
  </FullscreenContent>
</template>
